import * as React from 'react';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import Popover from 'components/popover/Popover';

import './popover-list.scss';

import type {
  PopoverListItem,
  PopoverListLineHeight,
  PopoverListWidth
} from './types';

type Props = {
  list: Array<PopoverListItem>,
  trigger?: JSX.Element,
  width?: PopoverListWidth,
  lineHeight?: PopoverListLineHeight,
  classNameList?: string,
  classNameWrapper?: string,
  classNamePopover?: string,
  classNameTrigger?: string
};

const PopoverList: React.FunctionComponent<Props> = ({
  list = [],
  trigger,
  width = 'normal',
  lineHeight = 'inherit',
  classNameList,
  classNameWrapper,
  classNamePopover,
  classNameTrigger
}: Props) => {
  if (isEmpty(list)) {
    return null;
  }

  const containerClasses = classnames('popover-list', classNameList);

  const bodyClasses = classnames('popover-list__body', {
    [`popover-list__body--width-${width}`]: Boolean(width),
    [`popover-list__body--line-height-${lineHeight}`]: Boolean(lineHeight)
  });

  return (
    <div className={containerClasses}>
      <Popover
        triggerComponent={trigger}
        classNameWrapper={classNameWrapper}
        classNamePopover={classNamePopover}
        classNameTrigger={classNameTrigger}
        showQuestionMark={isNil(trigger)}
      >
        <div className={bodyClasses}>
          {
            list.map(item => (
              <div
                key={`popover-list--${item.title || item.body}`}
                className="popover-list__section"
              >
                {
                  item.title && (
                    <div className="popover-list__title">
                      {item.title}
                    </div>
                  )
                }
                <div>
                  {item.body}
                </div>
              </div>
            ))
          }
        </div>
      </Popover>
    </div>
  );
};

export default PopoverList;
